import scrollMonitor from 'scrollmonitor';
import debounce from 'lodash/debounce';
import { requestTimeout } from '../util';

const $header = $('.site-header');
const $headerWatcher = $('.site-header-watcher');
const $scrollToButton = $('.page-header__scroll button');
const $banner = $('#marketing-banner');
const $bannerBtn = $('#banner-close-btn');

if (Cookies.get('banner')) {
    $banner.remove();
}

const closeBanner = () => {
    $bannerBtn.click(() => {
        $banner.remove();
        Cookies.set('banner', true, {
            expires: new Date(Date.now() + 60000),
        });
    });
};

const setupNavScroll = () => {
    let siteHeaderWatcher = null;

    const handleNavScroll = () => {
        siteHeaderWatcher = scrollMonitor.create($headerWatcher.get(0), -15);
        siteHeaderWatcher.lock();

        siteHeaderWatcher.exitViewport(() => {
            if (!$header.hasClass('site-header--stuck')) {
                $header.addClass('site-header--hidden');
                $banner.addClass('hidden');

                requestTimeout(() => {
                    $header.addClass('site-header--stuck');
                    $header.removeClass('site-header--hidden');
                }, 100);
            }
        });

        siteHeaderWatcher.enterViewport(() => {
            $header.removeClass('site-header--stuck');
            $banner.removeClass('hidden');
        });
    };

    handleNavScroll();

    $(window).on(
        'resize',
        debounce(() => {
            siteHeaderWatcher.destroy();
            handleNavScroll();
        }, 200)
    );
};

const setupMenu = () => {
    $('.site-header__menu-btn').on('click', e => {
        $('html').toggleClass('js-mobile-menu-opened');
    });
};

const setupScrollTo = () => {
    if (!$scrollToButton.length) {
        return;
    }

    const getOffset = () => {
        if (window.innerWidth >= 768) {
            return 70;
        }

        if (window.innerWidth >= 1024) {
            return 66;
        }

        return 55;
    };

    $scrollToButton.on('click', e => {
        $.scrollTo('.page-content-wrapper', 400, { offset: -getOffset() });
    });
};

export default {
    can: () => true,
    run: () => {
        closeBanner();
        setupMenu();
        setTimeout(setupNavScroll, 500);
        setupScrollTo();
    },
};
